module.exports = __webpack_public_path__ + "img/137.2.98334d00.png";